import React from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import dynamic from 'store/dynamic';
import { hot } from 'react-hot-loader/root';

// 全局样式
import 'maker/components/Style';

const App = () => (
  <BrowserRouter>
    <Switch>
      <Route path={'/normal/experiment/queryDetailInfo'} exact component={dynamic({
        component: () => import('./routes/Experiment/QueryDetailInfo'),
      })} />
      {/* Redirect all other paths to the only valid route */}
      <Redirect to={'/normal/experiment/queryDetailInfo'} />
    </Switch>
  </BrowserRouter>
);

export default hot(App);
